export enum ModelType {
  CUSTOM = 'custom',
  TRANSITION_ELEMENT = 'transitionElement',
}
